import React from 'react';
import { Divider, Typography, Box, Stack } from '@mui/material';

import DetailItem from 'components/Staff/ItemDetail';
import Profile from 'components/Staff/Profile';
import Button from 'components/Common/CustomButton';
import { dateFormat, formatAmount } from 'utils/helpers';
import CardWrapper from '../CardWrapper';
import TransactionDetailsSkeleton from 'components/Skeleton/TransactionDetailsSkeleton';

interface ButtonProps {
    loading: boolean;
    onClick?: () => void;
    disabled: boolean;
    title: string;
}
interface TransDetailType {
    title?: string;
    details?: any;
    loading?: boolean;
    showButtons?: boolean;
    backButtonNavigation?: () => void;
    cancelButtonProps?: ButtonProps;
    submitButtonProps?: ButtonProps;
    children?: React.ReactNode;
    sectionTitle?: React.ReactNode;
}
interface DetailType {
    firstName: string;
    lastName: string;
    name?: string;
    balance?: number;
    confirmationCode?: string | number;
    transactionDateTime: string;
    username?: string;
    logoUrl?: string;
    description?: string;
    transactionStatus?: string;
    note?: string;
}

const commonStyles = { fontSize: 16, color: '#1F2937', fontWeight: 400 };

export default function TransactionDetails({
    title,
    details,
    loading,
    showButtons,
    backButtonNavigation,
    submitButtonProps,
    cancelButtonProps,
    children,
    sectionTitle,
}: TransDetailType) {
    const { balance, confirmationCode, transactionDateTime, logoUrl, name, username, note }: DetailType = details || {};
    return (
        <>
            <CardWrapper backButtonNavigation={backButtonNavigation} sx={{ p: '1vh', mx: '10vh' }}>
                {loading ? (
                    <TransactionDetailsSkeleton />
                ) : (
                    <Box
                        sx={{
                            paddingTop: '2rem',
                            marginLeft: '20px',
                        }}
                    >
                        {
                            <Box
                                display="flex"
                                flexDirection={'column'}
                                justifyContent="space-between"
                                alignItems="flex-start"
                                sx={{ marginBottom: 2, marginLeft: '60px' }}
                            >
                                {sectionTitle ? (
                                    <Typography> {sectionTitle}</Typography>
                                ) : (
                                    <>
                                        <Typography sx={{ fontSize: '20px', fontWeight: '700' }} variant="h1">
                                            Invoice #: {confirmationCode}
                                        </Typography>
                                        <span style={{ fontSize: 14, color: '#1F2937', fontWeight: 300 }}>
                                            Date : {dateFormat(transactionDateTime, 'MMMM DD, YYYY')}
                                        </span>
                                    </>
                                )}
                            </Box>
                        }
                        <Divider sx={{ my: 1, marginLeft: '60px' }} />
                        <Typography sx={{ ...commonStyles, mt: 6, marginLeft: '60px' }} variant="h1">
                            {title}
                        </Typography>
                        <Stack sx={{ marginLeft: '120px' }}>
                            <Profile width={'25rem'} user={{ name, username: username, logoUrl }} showIcon="showIcon" />
                        </Stack>
                        <Typography sx={{ ...commonStyles, mt: 6, marginLeft: '120px' }} variant="h1">
                            Request Details
                        </Typography>
                        <Divider sx={{ my: 1, marginLeft: '120px' }} />
                        <div style={{ marginBottom: '12vh', marginLeft: '120px' }}>
                            {sectionTitle && (
                                <DetailItem
                                    fontWeight={400}
                                    textAlign="left"
                                    labelWidth={'30%'}
                                    label="Date"
                                    value={dateFormat(transactionDateTime)}
                                />
                            )}
                            <DetailItem fontWeight={400} textAlign="left" labelWidth={'30%'} label="Amount" value={formatAmount(balance)} />
                            <DetailItem fontWeight={400} textAlign="left" labelWidth={'30%'} label="Note" value={note} />
                        </div>
                        {children}
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                            {showButtons && (
                                <>
                                    <Button sx={{ width: '40%' }} {...submitButtonProps} />
                                    <Button sx={{ width: '40%', backgroundColor: '#B91C1C' }} {...cancelButtonProps} />
                                </>
                            )}
                        </Box>
                    </Box>
                )}
            </CardWrapper>
        </>
    );
}
